<template>
  <el-container class="landing-page-main-box">
    <el-aside class="landing-page-left-box">
      <type-of-requests />

      <processing-of-requests />

      <progress-of-requests />
    </el-aside>

    <el-main class="landing-page-right-box">
      <ApolloQuery
        :query="getTicketStatisticsQuery"
        :fetch-policy="'network-only'"
      >
        <template slot-scope="{result: {data}, isLoading}">
          <el-container
            v-if="isLoading"
            v-loading="isLoading"
            class="righ-side-info loading-box"
          />
          <transition name="el-fade-in-linear">
            <el-container
              v-if="!isLoading"
              class="righ-side-info"
            >
              <two-row-info
                v-for="(info, index) in rightSideInfos(data.ticketsStatistics)"
                :key="index"
                :font-size="info.fontSize"
                :data-color="info.dataColor"
              >
                <template #data>
                  {{ info.infoData }}
                </template>
                <template #title>
                  {{ info.infoTitle }}
                </template>
              </two-row-info>
            </el-container>
          </transition>
        </template>
      </ApolloQuery>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import {
  TicketsStatisticsQuery,
  TicketStatistics
} from '@/types/graphql'

import TypeOfRequests from '@/components/Helpdesk/LandingPage/TypeOfRequests.vue'
import ProcessingOfRequests from '@/components/Helpdesk/LandingPage/ProcessingOfRequests.vue'
import ProgressOfRequests from '@/components/Helpdesk/LandingPage/ProgressOfRequests.vue'

import TwoRowInfo from '@/components/UI/TwoRowInfo.vue'

@Component({
  components: {
    TypeOfRequests,
    ProcessingOfRequests,
    ProgressOfRequests,
    TwoRowInfo
  }
})
export default class extends Vue {
  private getTicketStatisticsQuery = TicketsStatisticsQuery

  private rightSideInfos(ticketStats: TicketStatistics | null) {
    if (!ticketStats) return []

    return [
      {
        infoTitle: this.$t('helpdesk.landingPage.averageLifespanTitle'),
        infoData: ticketStats.average_lifespan_tickets.toString() + ' ' + this.$t('helpdesk.landingPage.day') + (ticketStats.average_lifespan_tickets > 1 ? 's' : ''),
        fontSize: 16,
        dataColor: 'hsl(40, 100%, 50%)'
      },
      {
        infoTitle: this.$t('helpdesk.landingPage.topTaggedTitle'),
        infoData: ticketStats.top_tagged_tickets,
        fontSize: 16,
        dataColor: 'hsl(170, 100%, 40%)'
      },
      {
        infoTitle: this.$t('helpdesk.landingPage.topCreatorTitle'),
        infoData: ticketStats.top_creator_tickets,
        fontSize: 16,
        dataColor: 'hsl(195, 100%, 50%)'
      }
    ]
  }
}
</script>

<style lang="scss">
  @import "@/css/helpdeskLandingPage.scss";
</style>
